<template>
  <ServiceCard 
    title="Database Design"
    subtitle="Optimized data architecture"
    description="Design and implement robust database solutions with performance optimization and data integrity."
    to="/services/database-design"
    
    gradient-start="#667eea"
    gradient-end="#764ba2"
    button-text="Learn More"
  />
</template>

<script setup>
import ServiceCard from '~/components/ServiceCard.vue';
</script>